import styled from "@emotion/styled";
import { Col, Container, Image, Row } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";
import BUTTON from "../button/Button.component";

const NoResultsContainer = styled(Container)<IStyledComponentProps>`
  &.no-results-container {
    margin-top: 20px;
    .no-results-icon {
      display: block;
      margin: 0 auto;
    }

    .number-badge {
      background-color: ${({ theme }) => theme.colors.grays.septenary};
      border-radius: 50%;
      color: white;
      height: 22px;
      left: 60px;
      margin: 0 auto;
      padding-left: 6px;
      position: relative;
      top: 20px;
      width: 22px;
      span {
        line-height: 21px;
        display: block;
        margin-left: 0.5px;
      }
    }

    h4 {
      color: ${({ theme }) => theme.colors.grays.septenary};
      font-family: ${({ theme }) => theme.fontFamilies.semiBold};
      text-align: center;
    }

    hr {
      margin: 24px auto;
      width: 460px;
      @media (max-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        width: 100%;
      }
    }

    p {
      color: ${({ theme }) => theme.colors.grays.septenary};
      text-align: center;

      &.no-projects-subheader {
        font-family: ${({ theme }) => theme.fontFamilies.semiBold};
        margin-bottom: 8px;
      }

      &.no-projects-subheader-link {
        font-family: ${({ theme }) => theme.fontFamilies.semiBold};
        margin-bottom: 8px;
        color: ${({ theme }) => theme.colors.brand.primary};
      }
    }
  }
`;

const ErrorColumn = styled(Col)<IStyledComponentProps>`
  &.error-column {
    text-align: center;
  }
`;

const ErrorRow = styled(Row)<IStyledComponentProps>`
  &.error-row {
    min-height: 560px;
  }
`;

const ErrorIcon = styled(Image)<IStyledComponentProps>`
  &.error-icon {
    width: 196px;
    height: 122px;
    left: 160px;
    margin-top: 24px;
  }
`;

const ErrorMainText = styled.div<IStyledComponentProps>`
  font-size: ${(props) => props.theme.utils.increaseFontSize(8)};
  font-family: ${(props) => props.theme?.fontFamilies?.semiBold};
  color: ${(props) => props.theme?.colors?.grays.septenary};
  margin-top: 24px;
`;

const ErrorSubText = styled.div<IStyledComponentProps>`
  font-family: ${(props) => props.theme?.fontFamilies?.regular};
  color: ${(props) => props.theme?.colors?.grays.septenary};
  width: 360px;
  margin: 24px auto 0;

  @media (max-width: ${({ theme }) =>
      theme.utils.getThemeBreakpoint("tablet")}) {
    width: 75%;
  }
`;

const ErrorButton = styled(BUTTON)<IStyledComponentProps>`
  background-color: ${({ theme }) => theme.colors?.cta.primary} !important;
  border: 1px solid ${({ theme }) => theme.colors?.cta.primary} !important;
  margin-top: 24px;
  margin-bottom: 24px;
  width: 120px;
`;

export default {
  NoResultsContainer,
  ErrorIcon,
  ErrorMainText,
  ErrorSubText,
  ErrorButton,
  ErrorColumn,
  ErrorRow,
};
